<template>
  <div class="tag_settings_container">
    <BaseTitle
      class="d-block mb-6"
      v-text="$t('organization_tag_settings.title')"
    />
    <div class="header">
      <BaseButton type="primary" icon="$mdiPlus" @click="editTag(null)">
        {{ $t("utils.create") }}
      </BaseButton>
    </div>
    <BaseDataTable
      class="table"
      :items="tags.results"
      :loading="tagFilter.loading"
      :options="{
        page: tagFilter.page,
        itemsPerPage: tagFilter.pageSize,
      }"
      :server-items-length="tags.count"
      :loading-text="$t('utils.loadingData')"
      @update:options="onPaginationChange"
    >
      <template #header>
        <thead>
          <tr>
            <th class="header-col">
              {{ $tc("utils.label", 3) }}
            </th>
            <th class="header-col">
              {{ $tc("utils.description", 3) }}
            </th>
            <th class="header-col text-end" />
          </tr>
        </thead>
      </template>
      <template #item="{ item }">
        <tr class="tab_row">
          <td>
            <OrganizationTag :tag="item" />
          </td>
          <td>
            <div class="description" v-text="item.description" />
          </td>
          <td>
            <div class="action_section">
              <BaseButtonIcon
                small
                color="primary"
                icon="$mdiPencilOutline"
                @click="editTag(item)"
              />
              <BaseButtonIcon
                small
                color="secondary"
                icon="$mdiTrashCanOutline"
                @click="deleteTag(item)"
              />
            </div>
          </td>
        </tr>
      </template>
    </BaseDataTable>

    <!-- dialogs -->
    <OrganizationTagDeleteDialog
      :dialog-state="dialogState.deleteTag"
      :tag="activeTag"
      @deleted="reloadTags()"
      @closed="onDialogCloseed()"
    />
    <OrganizationTagEditDialog
      :dialog-state="dialogState.editTag"
      :tag="activeTag"
      @saved="reloadTags()"
      @closed="onDialogCloseed()"
    />
  </div>
</template>

<script>
import TagApi from "@/modules/Folder/Services/tag.api.js";

import OrganizationTag from "./OrganizationTag.vue";
import OrganizationTagDeleteDialog from "./OrganizationTagDeleteDialog.vue";
import OrganizationTagEditDialog from "./OrganizationTagEditDialog.vue";

export default {
  name: "OrganizationTagSettings",
  components: {
    OrganizationTag,
    OrganizationTagDeleteDialog,
    OrganizationTagEditDialog,
  },
  data() {
    return {
      activeTag: null,
      tags: {
        results: [],
        count: 0,
        next: 0,
        previous: 0,
      },
      tagFilter: {
        page: 1,
        pageSize: 10,
        loading: false,
      },
      filters: {
        name: null,
        description: null,
      },
      activeFilters: [],
      searchTimeoutRef: null,
      dialogState: {
        deleteTag: false,
        editTag: false,
      },
    };
  },
  mounted() {
    this.fetchTags();
  },
  methods: {
    async fetchTags() {
      this.tagFilter.loading = true;
      try {
        const res = await TagApi.getOrganizationTagList(
          this.$route.params.organizationId,
          {
            page: this.tagFilter.page,
            pageSize: this.tagFilter.pageSize,
          }
        );

        this.tags = res.data;
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.tagFilter.loading = false;
    },
    reloadTags() {
      this.tags = {
        results: [],
        count: 0,
        next: 0,
        previous: 0,
      };
      this.tagFilter = {
        page: 1,
        pageSize: 10,
        loading: false,
      };
      this.fetchTags();
    },
    onPaginationChange(pagination) {
      this.tagFilter.page = pagination.page;
      this.tagFilter.pageSize =
        pagination.itemsPerPage < 0 ? this.tags.count : pagination.itemsPerPage;
      this.fetchTags();
    },
    deleteTag(tag) {
      this.activeTag = tag;
      this.dialogState.deleteTag = true;
    },
    editTag(tag) {
      this.activeTag = tag;
      this.dialogState.editTag = true;
    },
    onDialogCloseed() {
      this.activeTag = null;
      this.dialogState.deleteTag = false;
      this.dialogState.editTag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tag_settings_container {
  margin-top: 24px;
  padding: 24px;
  background: #fff;

  .header-col {
    color: #353542 !important;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 150% */
  }
}
</style>
